// @ts-ignore
import { UserStatsNotFoundError } from "@seneca/stats-service-client";

import { throttledLogError } from "seneca-common/utils/apiStates";

export default function statsServiceErrorHandler(
  error: Error,
  {
    errorAction,
    successAction
  }: {
    successAction: (arg0?: any) => void;
    errorAction: (arg0?: any) => void;
  }
): void {
  if (error instanceof UserStatsNotFoundError) {
    return successAction();
  }

  errorAction();
  throttledLogError(error);
}
